import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import store from '@store';


function AppProviders({ children }) {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '100559398805-jpsagpjpkjir75c5en6eo4nvbjeke42o.apps.googleusercontent.com';
  
  return (
    <GoogleOAuthProvider
      clientId={googleClientId}
    >
      <Provider store={store}>{children}</Provider>
    </GoogleOAuthProvider>
  );
}

export default AppProviders;